import { Chapter } from './chapter';
import { UserVideo } from './user-video';

export class Trigger{

  legacy: boolean = false; // 旧フォームの場合:true ※trueの場合、変更不可、保存しない

  baseContent: any; // Video, ContentList, Content
  nextContent: any; // Video, ContentList, Content

  nextType:'MainContent'| 'SubContentList' | 'SubContent'; // 遷移先タイプ
  nextMainContentHash:string; // 遷移先Content
  nextSubContentListHash:string; // 遷移先ContentList
  nextSubContentHash:string; // 遷移先SubContent

  videoTriggerType:'Video' | 'Chapter' | 'Seconds' = 'Video';

  // videoTriggerType == video
  videoPosition:'Start' | 'End' = 'Start';

  // videoTriggerType == chapter
  chapterPosition:'Start' | 'End' = 'Start';
  chapterIndex:number = 0;
  chapter:Chapter;

  seconds:number = 0;

  // triggerの矢印で使用
  leaderLine:any;

  // Player側で使用
  triggered: boolean = false;
  skipped: boolean = false;
  
  constructor(object = null){

    if(object){
      this.set(object);
    }
  };

  set(object){

    if(object.legacy){
      this.legacy = object.legacy;
    }

    if(object.nextMainContentHash){
      this.nextMainContentHash = object.nextMainContentHash;
    }
    if(object.nextSubContentListHash){
      this.nextSubContentListHash = object.nextSubContentListHash;
    }
    if(object.nextSubContentHash){
      this.nextSubContentHash = object.nextSubContentHash;
    }

    if(object.nextType){
      this.nextType = object.nextType;
    }
    else{
      if(this.nextSubContentHash){
        this.nextType = "SubContent";
      }
      else if(this.nextSubContentListHash){
        this.nextType = "SubContentList";        
      }
      else{
        this.nextType = "MainContent";
      }
    }


    if(object.videoTriggerType){
      this.videoTriggerType = object.videoTriggerType;
    }
    if(object.videoPosition){
      this.videoPosition = object.videoPosition;
    }
    if(object.chapterIndex != 0){
      this.chapterIndex = object.chapterIndex;
    }
    if(object.chapterPosition){
      this.chapterPosition = object.chapterPosition;
    }
    if(object.seconds != 0){
      this.seconds = Number(object.seconds);
    }
    if(object.chapter){
      this.chapter = new Chapter(object.chapter);
    }
  }

  setChapterWithUserVideo(userVideo:UserVideo){
    let chapter:Chapter = userVideo.chapters[this.chapterIndex];
    this.chapter = chapter;
  }

  static convertSecondsFromChapterTrigger(trigger, userVideo:UserVideo):number{
    let seconds:number;

    if(trigger.videoTriggerType == "Video"){
      if(trigger.videoPosition == "Start"){
        seconds = 0;
      }
      if(trigger.videoPosition == "End"){
        seconds = Number(userVideo.time);
      }
    }
    else if(trigger.videoTriggerType == "Chapter"){
      let chapter:Chapter = userVideo.chapters[trigger.chapterIndex];
      if(trigger.chapterPosition == "Start"){
        seconds = Number(chapter.time);
      }
      if(trigger.chapterPosition == "End"){
        if(userVideo.chapters.length <= trigger.chapterIndex + 1){
          seconds = Number(userVideo.time);
        }
        else{
          seconds = Number(userVideo.chapters[trigger.chapterIndex + 1].time);
        }        
      }  
    }
    else{
      seconds = Number(trigger.seconds);
    }

    return seconds;
  }

  static convertToSeconds(timeString:string = ""):number{
    if(! timeString){
      return 0;
    }

    const pattern = /^([0-9]{1,2}:)?[0-9]{1,2}:[0-9]{1,2}$/;
    let result = timeString.match(pattern);
    if(! result){
      return 0;
    }

    let timeParts = timeString.split(':');
    if(timeParts.length == 3){
      // h:mm:ss
      return parseInt(timeParts[0]) * 3600 + parseInt(timeParts[1]) * 60 + parseInt(timeParts[2]);
    }
    if(timeParts.length == 2){
      // mm:ss
      return parseInt(timeParts[0]) * 60 + parseInt(timeParts[1]);
    }
    if(timeParts.length == 1){
      // ss
      return parseInt(timeParts[0]);
    }    
  }

  // triggerが同時に複数発生した際に
  // ・secondsで並び替える
  // videoTriggerType(seconds, chapter, video)で並び替える
  static compareSeconds(aTrigger:Trigger, bTrigger:Trigger) {

    let comparison = 0;
    if(aTrigger.seconds == bTrigger.seconds){

      // 旧フォームの場合は先に表示する
      if(aTrigger.legacy){
        comparison = -1;
        return comparison;
      }
      else if(bTrigger.legacy){
        comparison = 1;
        return comparison;
      }      

      // 遷移先がContentListを優先
      if(! aTrigger.nextSubContentListHash && bTrigger.nextSubContentListHash){
        comparison = 1;
      }
      else if(aTrigger.nextSubContentListHash && ! bTrigger.nextSubContentListHash){
        comparison = -1;
      }
    }
    else if(aTrigger.seconds > bTrigger.seconds){
      comparison = 1;
    }
    else if(aTrigger.seconds < bTrigger.seconds){
      comparison = -1;
    }
    return comparison;
  }

  getTriggerObject(){

    let triggerObject = {
      nextType: this.nextType,
    };

    if(this.nextMainContentHash){
      triggerObject["nextMainContentHash"] = this.nextMainContentHash;
    }
    if(this.nextSubContentListHash){
      triggerObject["nextSubContentListHash"] = this.nextSubContentListHash;
    }
    if(this.nextSubContentHash){
      triggerObject["nextSubContentHash"] = this.nextSubContentHash;
    }

    if(this.videoTriggerType){
      triggerObject["videoTriggerType"] = this.videoTriggerType;
      triggerObject["seconds"] = this.seconds;
      if(this.videoTriggerType == "Video"){
        triggerObject["videoPosition"] = this.videoPosition;
      }
      else if(this.videoTriggerType == "Chapter"){
        triggerObject["chapterIndex"] = this.chapterIndex;
        triggerObject["chapterPosition"] = this.chapterPosition;
      }
    }
    return triggerObject;
  }

  static getLeaderLinePathId(leaderLineId){
    return 'leader-line-' + leaderLineId + '-line-path';
  }
  static getclickableLineId(leaderLineId){
    return 'leader-line-' + leaderLineId + '-line-clickable';
  }
  
  static isSame(trigger, nextType:string, nextMainContentHash, nextSubContentListHash = null, nextSubContentHash = null){
    if(trigger && trigger.nextType == nextType){
      if(nextType == "MainContent"){
        if(trigger.nextMainContentHash == nextMainContentHash){
          return true;
        }
      }
      else if(nextType == "SubContentList"){
        if(trigger.nextSubContentListHash == nextSubContentListHash){
          return true;
        }        
      }
      else if(nextType == "SubContent"){
        if(trigger.nextSubContentHash == nextSubContentHash){
          return true;
        }
      }
    }
    return false;
  }


}